<script lang="ts">
	import { HighlightedText } from '@repo/commons/components'

	interface Props<T extends string | number> {
		value: T
		name: string
		label: string
		highlightPattern?: string
		checked: boolean
		disabled: boolean
		size?: 'medium' | 'small'
		onchange: (event: Event) => void
		onHighlightMatch?: (match: string, isExactMatch: boolean) => void
	}

	let {
		value,
		name,
		label = '',
		highlightPattern = '',
		checked = false,
		disabled = false,
		size = 'medium',
		onchange = () => {},
		onHighlightMatch = () => {}
	}: Props<string> = $props()
</script>

<label class="radio-container">
	<input type="radio" {name} value={String(value)} {checked} {disabled} {onchange} />
	<span class="radio-circle" class:checked class:disabled class:small={size === 'small'}></span>
	<span class="radio-label" class:small={size === 'small'}>
		<HighlightedText text={label} pattern={highlightPattern} {onHighlightMatch} />
	</span>
</label>

<style>
	.radio-container {
		@apply flex items-center relative cursor-pointer select-none;
	}

	input[type='radio'] {
		@apply absolute opacity-0 cursor-pointer h-0 w-0;
	}

	.radio-circle {
		@apply flex-none border border-[#002c4d]/50 relative h-8 w-8 bg-white rounded-full mr-3 flex items-center justify-center transition-all duration-200 ease-in-out;
	}

	.radio-circle.small {
		@apply h-6 w-6 mr-3;
	}

	.radio-circle.checked {
		@apply bg-brand border-brand;
	}

	.radio-circle.checked::after {
		content: '';
		@apply absolute w-3 h-3 rounded-full bg-white transition-all duration-200 ease-in-out;
	}

	.radio-circle.small.checked::after {
		@apply w-2 h-2;
	}

	.radio-circle.disabled {
		@apply border-gray-300 cursor-not-allowed;
	}

	.radio-label {
		@apply text-[#001626]/90 text-base truncate;
	}

	.radio-label.small {
		@apply text-base;
	}

	input[type='radio']:disabled ~ .radio-label {
		@apply text-gray-400;
	}
</style>
